import React from 'react'
// @ts-ignore no types
import { Button } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'

const ContractButton = () => {
  const { listing } = useListingContext()
  return (
    <Button
      elmId='contract_info_cta'
      link={`/dashboard/post-auction/purchased-homes/${listing.listing_id}`}
      role='primary'
      tag='a'
      target='_self'
    >
      Go to Contracting
    </Button>
  )
}

export default ContractButton
